
export const reviewSchema = {
  title: "Review Your Information",
  type: "object",
  properties: {
    reviewSummary: {
      type: "object",
      title: "",
      description: "Please review all the information you have provided before submitting",
    },
  },
};

export const reviewUiSchema = {
  reviewSummary: {
    "ui:field": "ReviewPdfField",
  },
};
